import { Box, Tab, Tabs, Typography } from '@mui/material'
import React, { useState } from 'react'
import SettingsIcon from '@mui/icons-material/Settings'
import PercentIcon from '@mui/icons-material/Percent'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import FeesManagement from '../FeesManagment/FeesManagement'
import AssetManagement from '../AssetManagement/AssetManagement'

const Settings: React.FC = () => {
    const [tab, setTab] = useState(0)

    return (
        <div className='common-layout flex-column'>
            <Box className="border-10 p-2 px-4 mixed-orange mb-4 both-circle d-flex align-items-center justify-content-between">
                <Box className="d-flex gap-3 align-items-center">
                    <Box sx={{
                        width: 30, height: 30, borderRadius: '10px',
                        background: 'rgba(255,255,255,0.15)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <SettingsIcon sx={{ color: '#fff', fontSize: 20 }} />
                    </Box>
                    <Box>
                        <Typography className='fs-24 text-white fw-medium' sx={{ lineHeight: 1.1 }}>
                            Settings
                        </Typography>
                        <Typography fontSize={11} color="rgba(255,255,255,0.5)" mt={0.2}>
                            Manage platform fees and tradable assets
                        </Typography>
                    </Box>
                </Box>

                <Tabs
                    value={tab}
                    onChange={(_, v) => setTab(v)}
                    sx={{
                        minHeight: 40,
                        background: 'rgba(0,0,0,0.2)',
                        borderRadius: '10px',
                        p: 0.5,
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root': {
                            minHeight: 36, borderRadius: '8px', fontSize: 13, fontWeight: 600,
                            color: 'rgba(255,255,255,0.6)', textTransform: 'none', px: 3, py: 0.5,
                            transition: 'all 0.2s',
                        },
                        '& .Mui-selected': {
                            color: '#fff !important',
                            background: 'rgba(255,255,255,0.18)',
                        },
                    }}
                >
                    <Tab
                        icon={<PercentIcon sx={{ fontSize: 16 }} />}
                        iconPosition="start"
                        label="Fees Management"
                    />
                    <Tab
                        icon={<CurrencyExchangeIcon sx={{ fontSize: 16 }} />}
                        iconPosition="start"
                        label="Asset Management"
                    />
                </Tabs>
            </Box>

            {tab === 0 && <FeesManagement />}
            {tab === 1 && <AssetManagement />}
        </div>
    )
}

export default Settings